/* Build your bed.

   A kit, not a matched set. The shop cannot honour one colour across every
   layer, because several pieces are sold in a single colour and the rest do
   not share a palette, so the page used to promise something it could not
   deliver. Each layer now carries its own colour, chosen from the colours that
   piece actually has in the chosen size, and the kit ships as the pieces
   picked.

   The rule that still shapes this file: the total shown is the total charged.
   The only discount is a real one: when the picked pieces are exactly the
   parts of a set the shop sells, the builder adds that set and shows its
   price. */
(function () {
  'use strict';
  var root = document.getElementById('em-build');
  if (!root) { return; }
  var raw = document.getElementById('em-build-data');
  var DATA;
  try { DATA = JSON.parse(raw.textContent); } catch (e) { return; }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = (window.EM && window.EM.money) || function (c) { return '$' + (c / 100).toFixed(2); };

  var SLOTS = ['sheets', 'base', 'protector', 'layer'];
  var state = { size: '', picks: {}, colours: {} };
  SLOTS.forEach(function (s) { state.picks[s] = ''; state.colours[s] = ''; });

  function key(x) { return String(x || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-'); }

  function axis(item, kind) {
    var names = item.optionNames || [], at = -1;
    names.forEach(function (n, i) {
      var l = String(n).toLowerCase();
      if (kind === 'colour' && (l === 'color' || l === 'colour')) { at = i; }
      if (kind === 'size' && l === 'size') { at = i; }
    });
    return at;
  }

  /* Blankets are sold by the cloth, "200 x 230 cm", not by the bed. Labelled
     "Queen (200 x 230 cm)" they answer to both. The trailing digit is what
     keeps a Twin XL from being read as a Twin. */
  function sizeMatches(value, want) {
    var v = key(value), w = key(want);
    if (!w) { return true; }
    if (v === w) { return true; }
    if (v.indexOf(w + '-') !== 0) { return false; }
    return /^[0-9]/.test(v.slice(w.length + 1));
  }

  function fitsSize(item, size) {
    var at = axis(item, 'size');
    if (at < 0) { return true; }
    return item.variants.some(function (v) { return sizeMatches(v.options[at], size); });
  }

  /* The exact variant for a piece in a size and a colour, or nothing. */
  function variantOf(item, size, colour) {
    var cAt = axis(item, 'colour'), zAt = axis(item, 'size'), want = null;
    item.variants.forEach(function (v) {
      if (want || !v.available) { return; }
      if (zAt >= 0 && size && !sizeMatches(v.options[zAt], size)) { return; }
      if (cAt >= 0 && colour && key(v.options[cAt]) !== key(colour)) { return; }
      want = v;
    });
    return want;
  }

  /* The colours this piece can actually be sent in, at this size. A piece sold
     in one colour returns nothing, and is simply shown without a choice. */
  function coloursFor(handle, size) {
    var item = DATA.items[handle];
    if (!item || axis(item, 'colour') < 0) { return []; }
    return (item.colours || []).filter(function (c) {
      return !!variantOf(item, size, c.name);
    });
  }

  function variantFor(handle) {
    var item = DATA.items[handle];
    if (!item) { return null; }
    var slot = item.slot;
    var wanted = state.colours[slot];
    var v = variantOf(item, state.size, wanted || null);
    if (v) { return v; }
    /* no colour chosen yet, or the chosen one does not come in this size */
    return variantOf(item, state.size, null);
  }

  /* Which steps have to be filled for the bed to be a bed. */
  var STEPS = DATA.steps || [];
  function slots(optional) {
    return STEPS.filter(function (s) { return !!s.optional === optional; });
  }
  function slotCanFill(slot, size) {
    return Object.keys(DATA.items).some(function (h) {
      var it = DATA.items[h];
      return it.slot === slot && fitsSize(it, size) && !!variantOf(it, size, null);
    });
  }
  function sizeWorks(size) {
    var req = slots(false);
    if (!req.length) { return true; }
    return req.every(function (s) { return slotCanFill(s.slot, size); });
  }

  /* ---- the set match ---------------------------------------------------
     A set may only stand in for the pieces picked when it is the same bed:
     the same size, and the same colour as every piece the shopper chose. The
     builder used to swap in whichever variant came first, so a White Queen
     build went into the cart as a Black Twin. Where the set cannot match, the
     pieces are sold as the pieces. */
  function setVariantFor(set, size, colours) {
    var names = set.optionNames || [];
    var zAt = -1, cAt = -1;
    names.forEach(function (n, i) {
      var l = String(n).toLowerCase();
      if (l === 'size') { zAt = i; }
      if (l === 'color' || l === 'colour') { cAt = i; }
    });
    var wanted = null;
    /* every colour the shopper chose, ignoring pieces that have none */
    var chosen = colours.filter(Boolean).map(key);
    var oneColour = chosen.length && chosen.every(function (c) { return c === chosen[0]; });
    (set.variants || []).forEach(function (v) {
      if (wanted || !v.available) { return; }
      if (zAt >= 0 && size && !sizeMatches(v.options[zAt], size)) { return; }
      if (cAt >= 0) {
        if (!chosen.length) { return; }               /* nothing to match on */
        if (!oneColour) { return; }                   /* a mixed kit is not this set */
        if (key(v.options[cAt]) !== chosen[0]) { return; }
      }
      wanted = v;
    });
    return wanted;
  }

  function matchSet(handles) {
    var k = handles.slice().sort().join('|');
    var set = DATA.sets.filter(function (s) {
      return (s.parts || []).slice().sort().join('|') === k;
    })[0];
    if (!set) { return null; }
    var cols = handles.map(function (h) {
      var it = DATA.items[h];
      return it ? state.colours[it.slot] : '';
    });
    var v = setVariantFor(set, state.size, cols);
    if (!v) { return null; }
    return { handle: set.handle, title: set.title, url: set.url,
             price: v.price, variantId: v.id };
  }

  function calc() {
    var order = ['protector', 'sheets', 'base', 'layer'];
    var parts = [];
    var unavailable = [];
    order.forEach(function (slot) {
      var h = state.picks[slot];
      if (!h || !DATA.items[h]) { return; }
      var v = variantFor(h);
      if (v) { parts.push({ handle: h, slot: slot, item: DATA.items[h], variant: v }); }
      else { unavailable.push(DATA.items[h].title); }
    });
    var full = parts.reduce(function (s, p) { return s + p.variant.price; }, 0);
    var named = parts.length ? matchSet(parts.map(function (p) { return p.handle; })) : null;

    /* The set is only worth switching to when it actually costs less. Sets are
       sold in one size, so at a small size the separate pieces can come to the
       same or less, and forcing the set there would charge more than the
       pieces the customer chose. */
    if (named && named.price >= full) { named = null; }

    var total = named ? named.price : full;
    return { parts: parts, full: full, total: total, named: named,
             save: named ? full - total : 0, unavailable: unavailable };
  }

  /* The side panel used to carry a drawing of the bed and then, briefly, the
     photographs of the pieces as well. Two previews stacked, neither of them
     saying more than the summary does in words, so both are gone. The summary
     lists what was picked, in what colour, at what price. */

  /* ---- painting -------------------------------------------------------- */
  function render() {
    $$('.em-size', root).forEach(function (b) {
      var sz = b.getAttribute('data-build-size');
      var ok = sizeWorks(sz);
      b.setAttribute('aria-pressed', String(sz === state.size));
      b.disabled = !ok;
      b.setAttribute('aria-disabled', String(!ok));
      b.title = ok ? '' : 'No bed can be finished in this size';
      if (!ok && state.size === sz) { state.size = ''; }
    });
    if (!state.size) {
      var firstOk = $$('.em-size', root).filter(function (b) { return !b.disabled; })[0];
      if (firstOk) { state.size = firstOk.getAttribute('data-build-size'); }
    }

    /* A piece is offered only when it comes in the chosen size and something
       is in stock. Colour is no longer a reason to refuse it, because each
       piece carries its own. */
    $$('.em-pick__i', root).forEach(function (b) {
      var slot = b.getAttribute('data-slot'), h = b.getAttribute('data-h');
      var item = DATA.items[h];
      var ok = false, why = '';
      if (!item) { why = 'Not available'; }
      else if (!fitsSize(item, state.size)) { why = 'Not made in ' + (state.size || 'this size'); }
      else if (!variantOf(item, state.size, null)) { why = 'Sold out in this size'; }
      else { ok = true; }
      /* The card printed product.price, which is the cheapest variant across
         every size, so at Queen a card could say $104.90 against $232.90 on
         the summary line. The page promises everything reprices at once, so
         the card has to say what this size costs. Where a size holds several
         prices the lowest is shown and labelled, never a bare number the
         summary would then beat. */
      var pEl = $('.em-pick__p', b);
      if (pEl && item) {
        var picked = state.picks[slot] === h;
        var wantC = picked && state.colours[slot] ? state.colours[slot] : null;
        var prices = [];
        item.variants.forEach(function (v) {
          if (!v.available) { return; }
          var zAt = axis(item, 'size'), cAt = axis(item, 'colour');
          if (zAt >= 0 && state.size && !sizeMatches(v.options[zAt], state.size)) { return; }
          if (cAt >= 0 && wantC && key(v.options[cAt]) !== key(wantC)) { return; }
          prices.push(v.price);
        });
        if (prices.length) {
          var lo = Math.min.apply(null, prices), hi = Math.max.apply(null, prices);
          pEl.textContent = (lo === hi) ? money(lo) : 'From ' + money(lo);
        }
      }
      b.setAttribute('aria-pressed', String(state.picks[slot] === h));
      /* Taken off the page rather than greyed out. A row of pieces a shopper
         cannot have is noise, and at Twin it was eight of them. */
      b.hidden = !ok;
      b.disabled = !ok;
      b.setAttribute('aria-disabled', String(!ok));
      b.title = why;
      if (!ok && state.picks[slot] === h) { state.picks[slot] = ''; state.colours[slot] = ''; }
    });

    /* A step with nothing left says so, instead of showing an empty space. */
    $$('.em-pick', root).forEach(function (grid) {
      var any = $$('.em-pick__i', grid).some(function (b) { return !b.hidden; });
      var msg = $('.em-pick__empty', grid.parentNode);
      if (!any) {
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'em-note em-pick__empty';
          grid.parentNode.insertBefore(msg, grid.nextSibling);
        }
        msg.textContent = 'Nothing in this layer is made in ' + (state.size || 'this size') + '.';
        msg.hidden = false;
      } else if (msg) {
        msg.hidden = true;
      }
    });

    /* the colour row for each layer, written from the piece chosen there */
    $$('.em-pickcol', root).forEach(function (row) {
      var slot = row.getAttribute('data-slot');
      var h = state.picks[slot];
      var list = h ? coloursFor(h, state.size) : [];
      if (!h || !list.length) {
        row.hidden = true;
        row.setAttribute('aria-hidden', 'true');
        if (h && state.colours[slot]) { state.colours[slot] = ''; }
        return;
      }
      /* keep the chosen colour if it survives the size, else take the first */
      var still = list.some(function (c) { return key(c.name) === key(state.colours[slot]); });
      if (!still) { state.colours[slot] = list[0].name; }
      row.hidden = false;
      row.setAttribute('aria-hidden', 'false');
      var label = $('.em-pickcol__l', row);
      if (label) { label.textContent = state.colours[slot]; }
      var wrap = $('.em-pickcol__s', row);
      var want = list.map(function (c) { return key(c.name); }).join('|');
      if (wrap.getAttribute('data-for') !== h + '::' + want) {
        wrap.setAttribute('data-for', h + '::' + want);
        wrap.innerHTML = list.map(function (c) {
          return '<button class="em-swatch" type="button" data-slot="' + slot +
            '" data-c="' + key(c.name) + '" style="background:' + c.hex +
            '" aria-label="' + c.name + '" aria-pressed="false"></button>';
        }).join('');
      }
      $$('.em-swatch', wrap).forEach(function (sw) {
        sw.setAttribute('aria-pressed',
          String(key(sw.getAttribute('data-c')) === key(state.colours[slot])));
      });
    });

    var r = calc();
    var lines = $('#em-build-lines');
    lines.innerHTML = r.parts.length
      ? r.parts.map(function (p) {
          var c = state.colours[p.slot];
          return '<div class="em-summary__row"><span>' + p.item.title +
                 (c ? ' <span class="em-summary__c">' + c + '</span>' : '') +
                 '</span><span>' + money(p.variant.price) + '</span></div>';
        }).join('')
      : '<p class="em-note">Pick a sheet set to start.</p>';

    var note = $('#em-build-note');
    if (!note) {
      note = document.createElement('p');
      note.id = 'em-build-note';
      note.className = 'em-note';
      $('#em-build-lines').parentNode.insertBefore(note, $('#em-build-save'));
    }
    var msgs = [];
    if (r.unavailable.length) {
      msgs.push(r.unavailable.join(' and ') + ' is not made in ' + state.size + '.');
    }
    note.textContent = msgs.join(' ');
    note.hidden = !msgs.length;

    var save = $('#em-build-save');
    save.innerHTML = (r.named && r.save > 0)
      ? '<div class="em-summary__row"><span>' + r.named.title + ', as a set</span>' +
        '<span>-' + money(r.save) + '</span></div>'
      : '';

    $('#em-build-total').textContent = money(r.total);
    var add = $('#em-build-add');
    add.disabled = !r.parts.length || r.unavailable.length > 0;

    var bar = $('#em-kitbar');
    if (bar) {
      var n = r.parts.length;
      bar.classList.toggle('em-kitbar--on', n > 0);
      bar.setAttribute('aria-hidden', String(n === 0));
      $('#em-kitbar-count').textContent = n === 1 ? '1 piece' : n + ' pieces';
      $('#em-kitbar-total').textContent = money(r.total);
      $('#em-kitbar-add').disabled = add.disabled;
    }

    writeHash();
  }

  /* ---- the hash, so a build can be sent to someone --------------------- */
  function writeHash() {
    var p = [];
    if (state.size) { p.push('size=' + state.size); }
    SLOTS.forEach(function (s) {
      if (!state.picks[s]) { return; }
      var v = state.picks[s];
      if (state.colours[s]) { v += ':' + key(state.colours[s]); }
      p.push(s + '=' + v);
    });
    history.replaceState(null, '', p.length ? '#' + p.join('&') : location.pathname);
  }
  function readHash() {
    (location.hash || '').replace(/^#/, '').split('&').forEach(function (bit) {
      var at = bit.indexOf('=');
      if (at < 1) { return; }
      var k = bit.slice(0, at), v = bit.slice(at + 1);
      if (k === 'size') { state.size = v; return; }
      /* a link from the matched-colour builder carries color=; it is no longer
         a thing the page has, and is ignored rather than left to break it */
      if (k === 'color' || k === 'colour') { return; }
      if (SLOTS.indexOf(k) === -1) { return; }
      var bits = v.split(':');
      if (!DATA.items[bits[0]]) { return; }
      state.picks[k] = bits[0];
      if (bits[1]) {
        /* the hash carries the colour slugged; every other reader of
           state.colours expects the name the product shows, so a shared
           link printed "milk-white" in the summary instead of "Milk White" */
        var named = (DATA.items[bits[0]].colours || []).filter(function (c) {
          return key(c.name) === key(bits[1]);
        })[0];
        state.colours[k] = named ? named.name : bits[1];
      }
    });
  }

  /* ---- events ---------------------------------------------------------- */
  root.addEventListener('click', function (e) {
    var size = e.target.closest('.em-size');
    if (size) { state.size = size.getAttribute('data-build-size'); render(); return; }

    var sw = e.target.closest('.em-swatch');
    if (sw && sw.getAttribute('data-slot')) {
      state.colours[sw.getAttribute('data-slot')] = sw.getAttribute('aria-label') || sw.getAttribute('data-c');
      render();
      return;
    }

    var skip = e.target.closest('.em-pick__skip');
    if (skip) {
      var s = skip.getAttribute('data-slot');
      state.picks[s] = ''; state.colours[s] = '';
      render();
      return;
    }

    var pick = e.target.closest('.em-pick__i');
    if (pick) {
      var slot = pick.getAttribute('data-slot'), h = pick.getAttribute('data-h');
      if (state.picks[slot] === h) { state.picks[slot] = ''; state.colours[slot] = ''; }
      else {
        state.picks[slot] = h;
        var first = coloursFor(h, state.size)[0];
        state.colours[slot] = first ? first.name : '';
      }
      render();
    }
  });

  $('#em-kitbar-add').addEventListener('click', function () {
    $('#em-build-add').click();
  });

  $('#em-build-share').addEventListener('click', function () {
    var btn = this, label = $('span', btn);
    var was = label.textContent;
    navigator.clipboard.writeText(location.href).then(function () {
      label.textContent = 'Link copied';
      setTimeout(function () { label.textContent = was; }, 1600);
    });
  });

  $('#em-build-add').addEventListener('click', function () {
    var r = calc();
    if (!r.parts.length) { return; }
    var btn = this, was = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';
    /* A real set is one product; anything else is its own pieces. */
    var items = r.named
      ? [{ id: r.named.variantId, quantity: 1 }]
      : r.parts.map(function (p) { return { id: p.variant.id, quantity: 1 }; });
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
      .then(function (out) {
        btn.disabled = false;
        btn.textContent = was;
        if (!out.ok) { btn.textContent = out.j.description || 'Not available'; return; }
        if (window.EM) { window.EM.getCart().then(window.EM.openDrawer); }
      })
      .catch(function () { btn.disabled = false; btn.textContent = was; });
  });

  /* ---- start ----------------------------------------------------------- */
  function start() {
    SLOTS.forEach(function (s) { state.picks[s] = ''; state.colours[s] = ''; });
    state.size = '';
    /* Land on the size the shop can actually dress. The section setting that
       was meant to mark a default renders aria-pressed false on every button,
       so the page fell back to the first one, Twin, and Twin is the worst
       stocked: it greys out eight pieces, six of which are sold as Twin XL
       instead. Counted from stock, so it follows the catalogue rather than a
       name typed in a setting. */
    var marked = $('.em-size[aria-pressed="true"]', root);
    var bestSize = null, bestCount = -1;
    $$('.em-size', root).forEach(function (b) {
      var sz = b.getAttribute('data-build-size');
      if (!sizeWorks(sz)) { return; }
      var n = 0;
      Object.keys(DATA.items).forEach(function (h) {
        var it = DATA.items[h];
        if (fitsSize(it, sz) && variantOf(it, sz, null)) { n++; }
      });
      if (n > bestCount) { bestCount = n; bestSize = sz; }
    });
    state.size = bestSize
      || (marked && marked.getAttribute('data-build-size'))
      || ($('.em-size', root) || {}).getAttribute
        && $('.em-size', root).getAttribute('data-build-size');
    readHash();
    render();
  }

  /* A build link opened by someone already on this page changes the fragment
     without reloading, so without this the link does nothing and the page sits
     on whatever the last person built. The back button needs it for the same
     reason. writeHash uses replaceState, which does not raise this event, so
     there is no loop. */
  window.addEventListener('hashchange', start);

  start();
})();
